import axios from 'axios'

const requestJpaas = {
  getDataJpaas: function (params) {
    return new Promise((resolved, rejected) => {
      axios({
        method: 'post',
        url: `/jimps/link.do`,
        // url: `http://app.gjzwfw.gov.cn/jimps/link.do`,
        data: params
      }).then(function (data) {
        if (data.data.code == 200) {
          const objData = data.data
          resolved(objData)
        } else {
          rejected(data)
        }
      })
        .catch(function (error) {
          rejected(error)
        })
    })
  },
  getData: function (params) {
    const baseParams = new URLSearchParams()
    baseParams.append('param', JSON.stringify(params))
    return requestJpaas.getDataJpaas(baseParams)
  }
}
export default requestJpaas
